import Propietarios from "./Propietarios";
export default Propietarios;